import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import ManageSubscriptionModal from "./modals/ManageSubscriptionModal";
import { Dropdown } from "react-bootstrap";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import OneSubscriberModal from "./modals/OneSubscriberModal";

export default function Members({ id }) {
  const [membersTokens, setMemmbersTokens] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [subscribers, setSubscribers] = useState([]);
  const [manageSubModal, setManageSubModal] = useState(false);
  const [selectedSub, setSelectedSub] = useState(null);
  const { user, dispatch } = useAuthContext();
  const [oneSubModal, setOneSubModal] = useState(false);
  const [selectedStripeSub, setSelectedStripeSub] = useState(null);

  const selectStripeSub = (e) => {
    setSelectedStripeSub(e);
  };

  const cancelFromOneSub = () => {
    setOneSubModal(false);
    setManageSubModal(true);
  };

  const navi = useNavigate();

  const cancelModal = () => {
    setManageSubModal(false);
    setOneSubModal(false);
  };

  let ConvertToCurrency = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  });

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const membersTokenResponse = await axios.get(
        `${ApiConnectionString}/api/Tokens?ClubId=${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setMemmbersTokens(membersTokenResponse.data);

      const subResponse = await axios.get(
        `${ApiConnectionString}/api/ClubMembers/club/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setSubscribers(subResponse.data);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }, 3000);
    }

    return () => clearTimeout(timeout);
  }, [id, user]);

  const collapsedTokens = useMemo(() => {
    const m = new Map();
    for (const t of membersTokens) {
      const key = `${t.viewAppUser?.username ?? ""}||${t.viewProduct?.name ?? ""}`;
      if (m.has(key)) {
        m.get(key).tokenAmount += t.tokenAmount ?? 0;
      } else {
        m.set(key, {
          username: t.viewAppUser?.username ?? "",
          productName: t.viewProduct?.name ?? "",
          tokenAmount: t.tokenAmount ?? 0,
        });
      }
    }
    return Array.from(m.values());
  }, [membersTokens]);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div>
        <div className="lightBlueBanner">
          <p className="fw-bold p-2">Members</p>
        </div>

        {membersTokens.length > 0 ? (
          <div>
            <p className="lead mb-2 fw-bold red-text">Classes Purchased</p>
            <table className="custom-table">
              <thead>
                <tr className="blueBanner">
                  <th>Username</th>
                  <th>Product</th>
                  <th>Classes Left</th>
                </tr>
              </thead>
              <tbody>
                {collapsedTokens.map((t) => (
                  <tr key={`${t.username}-${t.productName}`}>
                    <td>{t.username}</td>
                    <td>{t.productName}</td>
                    <td>{t.tokenAmount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p></p>
        )}
        <p className="lead mb-2 fw-bold red-text">List of Subscribers</p>
        {subscribers.length > 0 ? (
          <table className="custom-table">
            <thead>
              <tr className="blueBanner">
                <th>Username</th>
                <th>Package</th>
                <th>Cost</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {subscribers.map((sub) => (
                <tr
                  key={sub.id}
                  onClick={() => {
                    setSelectedSub(sub);
                    setOneSubModal(true);
                  }}
                >
                  <td>{sub.viewBookingProfile.username}</td>
                  <td>{sub.viewProduct.name}</td>
                  <td>
                    {ConvertToCurrency.format(sub.price / 100)} per {sub.viewProduct.interval}
                  </td>
                  <td>
                    {sub.cancelPending ? (
                      <span className="badge bg-warning">Cancel Pending</span>
                    ) : (
                      <span className="badge bg-success">Active</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-muted">No subscribers found</p>
        )}

        {manageSubModal && (
          <ManageSubscriptionModal
            cancelModal={cancelModal}
            selectedSub={selectedSub}
            fetchData={fetchData}
            selectedStripeSub={selectedStripeSub}
          />
        )}

        {oneSubModal && (
          <OneSubscriberModal
            selectStripeSub={selectStripeSub}
            ConvertToCurrency={ConvertToCurrency}
            cancelFromOneSub={cancelFromOneSub}
            cancelModal={cancelModal}
            selectedSub={selectedSub}
          />
        )}
      </div>
    );
  }
}
